<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              国家地区：
              <el-select
                v-model="searchData.country_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.country_list"
                  :key="option.id"
                  :label="option.value"
                  :value="option.id"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              角色搜索：
              <el-select
                v-model="searchData.roleid"
                @change="clearTeacher"
                clearable>
                <el-option
                  v-for="item in constDict.roleids"
                  :key="item.roleid"
                  :label="item.name"
                  :value="item.roleid"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              咨询老师：
              <el-select
                v-model="searchData.teacher_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in optionTeacherList"
                  :key="option.key"
                  :label="option.name"
                  :value="option.key"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              转化时间：
              <el-date-picker
                v-model="searchData.timeline"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="16">
              渠道来源：
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="searchBottom">
              <el-button type="primary" class="jm-input-common3" @click="init()">搜索</el-button>
            </el-col>
          </el-row>
          <p>
            数据说明
            <el-tooltip
              placement="right"
              effect="light">
              <div slot="content">
                2024.01.03
                <ul>
                  <li>原始分配资源数：创建时间为当前日期，初始分配老师资源总数</li>
                  <li>当前承接资源数：创建时间为当前日期，当前承接老师资源总数</li>
                  <li>签约数：签约时间为当前日期的签约和解约数（包含公海资源）</li>
                  <li>转化率：签约数/当前承接资源数</li>
                  <li>公海分配数：公海工具分配时间为当前日期的公海资源数（包含放弃与最终放弃资源）</li>
                  <li>解约数：签约时间为当前日期的解约数（包含公海资源）</li>
                  <li>放弃数：资源创建时间为当前日期的放弃资源数（包含公海资源）</li>
                  <li>长期跟进（年份）：当前年份长期跟进的资源数（更新时间：日本为当年6月，美、加、新/马为当年7月，韩国为当年10月。）</li>
                </ul>
              </div>
              <i class="el-icon-question blue"/>
            </el-tooltip>
          </p>

          <jm-tableList
            v-if="searchData"
            url="/index/bi.teacher/getSayerPage"
            :refresh="refresh"
            :search-data="searchData"
            :no-pagination="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';

let constDict = {
  year: ['全部'],
  month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      refresh: false,
      searchData: {
        teacher_id: [],
        timeline: [],
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: '',
        },
        roleid: '',
        country_id: [],
      }
    };
  },
  components: {
    jmChannel,
    jmTableList
  },
  created() {
    this.$http
      ._get({
        url: '/index/bi.teacher/searchDs'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        this.searchData.roleid = typeof this.constDict.roleids === 'object' ? this.constDict.roleids[0].roleid : this.constDict.roleids;
        this.setSearchTime();
        this.init();
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    },
    setSearchTime() {
      let date = new Date();
      let dateNow = date.toLocaleDateString();
      let startMonth = dateNow.replace(RegExp('([0-9]+)$', ''), '');
      dateNow = dateNow.replace(RegExp('/', 'g'), '-');
      startMonth = startMonth.replace(RegExp('/', 'g'), '-');
      this.searchData.timeline = [`${startMonth}1`, dateNow];
    },
    clearCountry() {
      this.searchData.country_id = [];
    },
    clearTeacher() {
      this.searchData.teacher_id = [];
    },
  },
  computed: {
    optionTeacherList() {
      if (this.constDict.teacher) {
        return this.constDict.teacher.filter((option) => {
          if (!this.searchData.roleid || this.searchData.roleid === -1) {
            return true;
          }
          return option.roleids.indexOf(this.searchData.roleid) > -1;
        });
      }
      return [];
    },
  }
};

</script>

<style scoped>
.searchForm *{
  padding: 5px;
}
.blue {
  color: #409EFF;
}
</style>
